import { NotEnoughSeats } from "features/subscriptions/components";

import BulkManageMobileDrawer from "common/components/BulkManageMobileDrawer";
import useAvailableLicensesCount from "common/hooks/useAvailableLicensesCount";
import type { WorkspaceAccount } from "common/types";

import { MANAGE_ACCOUNTS_ACTIONS } from "../../constants";
import AssignSeats from "../ManageAccounts/AssignSeats";
import ManageInteractions from "../ManageAccounts/ManageInteractions";
import UpdateProxies from "../ManageAccounts/UpdateProxies";

export interface ManageAccountsProps {
  selectedAccounts: WorkspaceAccount[];
}

export default function ManageAccounts({
  selectedAccounts,
}: ManageAccountsProps) {
  const { availableLicensesCount } = useAvailableLicensesCount();

  return (
    <BulkManageMobileDrawer
      drawerLabel="accounts"
      actions={MANAGE_ACCOUNTS_ACTIONS}
      selection={selectedAccounts}
      renderActionComponent={({ action, onBack, onClose }) => {
        const noLicenseAccounts = selectedAccounts.filter(
          ({ license, type }) => type === "user" && !license,
        );
        if (
          action === "seats" &&
          availableLicensesCount < noLicenseAccounts.length
        ) {
          return (
            <NotEnoughSeats
              noSeatAccountIds={noLicenseAccounts.map(({ id }) => id)}
              mixpanelSource="upsell_seat"
            />
          );
        }
        const props = {
          selectedAccounts,
          onBack,
          onClose,
        };
        if (action === "seats") {
          return <AssignSeats {...props} />;
        }
        if (action === "proxy") {
          return <UpdateProxies {...props} />;
        }
        if (action === "interactions") {
          return <ManageInteractions {...props} />;
        }
      }}
    />
  );
}
